import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getEbBanksWithAccounts, updateEbAccounts } from 'client/api/banking'
import { AccountsUpdateRequest, BankWithAccountsState } from 'client/Interfaces/Banking'

import { BankingProviders } from './BankingModals/ConnectBankModal'

const bankWithAccountsInitialState: BankWithAccountsState = {
  bank: null,
  status: 'idle',
  error: null,
}

export const fetchBankWithAccountsByBankId = createAsyncThunk(
  'bankWithAccounts/fetchBankWithAccountsByBankId',
  async (selectedBankingProvider: string) => {
    if (selectedBankingProvider === BankingProviders.eb) {
      const response = await getEbBanksWithAccounts()
      return response.banks[0]
    }
  },
)

export const updateBankWithAccounts = createAsyncThunk(
  'bankWithAccounts/updateBankWithAccounts',
  async (accountUpdateRequest: AccountsUpdateRequest) => {
    if (accountUpdateRequest.selectedBankingProvider === BankingProviders.eb) {
      const response = await updateEbAccounts(accountUpdateRequest.accountsUpdateBody)
      return response.banks[0]
    }
  },
)

const bankWithAccounts = createSlice({
  name: 'bankWithAccounts',
  initialState: bankWithAccountsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // pending
      .addCase(fetchBankWithAccountsByBankId.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(updateBankWithAccounts.pending, (state, action) => {
        state.status = 'loading'
      })

      // succeed
      .addCase(fetchBankWithAccountsByBankId.fulfilled, (state, action) => {
        state.bank = action.payload
        state.status = 'succeed'
      })
      .addCase(updateBankWithAccounts.fulfilled, (state, action) => {
        state.bank = action.payload
        state.status = 'succeed'
      })

      // failed
      .addCase(fetchBankWithAccountsByBankId.rejected, (state, action) => {
        state.bank = null
        state.error = action.error
        state.status = 'failed'
      })
      .addCase(updateBankWithAccounts.rejected, (state, action) => {
        state.error = action.error
        state.status = 'failed'
      })
  },
})

export default bankWithAccounts.reducer
